import { rfqQuoteDetailsPageContainerStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsPageContainer";

Object.assign(rfqQuoteDetailsPageContainerStyles, {
    rigthColumnGridItem: { width: [12, 12, 6, 5, 4] },

});
